import getBridges from "./bridges/get-bridges";

declare global {
  interface Window {
    // @ts-ignore
    mxpDataLayer: any[];
  }
}

export function track(
  name: string,
  params?: { [k: string]: string | undefined }
): void {
  const eventParams = {
    ...(params || {}),
    APP_VERSION_ELIXIR_DR: import.meta.env.APP_VERSION_ELIXIR_DR,
  };

  const formattedEvent = { eventName: name, extraParams: eventParams };

  if (!window.mxpDataLayer) {
    window.mxpDataLayer = [];
  }

  window.mxpDataLayer.push(formattedEvent);
  getBridges()?.track?.(name, eventParams);
}

export const serializeErrorForTracking = (err: Error | string) => {
  if (!err) return undefined;
  if (typeof err === "string") return err;
  return JSON.stringify({
    errorName: err?.name,
    errorMessage: err?.message,
    errorStack: err?.stack,
    errorCause: err?.cause,
  });
};
